;(function($, _) {

	// *************************************************************************
	// GoogleMap class
	// *************************************************************************

	function GoogleMap() {
		this.map = null;
		this.autocomplete = null;
		this.routing = null;
		this.infoWindow = null;

		this.destination = { lat: 50.071771, lng: 15.988460 };

		this.mapElement = document.getElementById("map");
		this.routeElement = document.getElementById("map-directions");
		this.autocompleteElement = document.getElementById("map-direction-from");

		this.$form = null;
		this.$submitButton = null;
	}
	GoogleMap.prototype = {
		constructor: GoogleMap,

		init: function() {
			// Init map
			this.map = new google.maps.Map(this.mapElement, {
				center: this.destination,
				zoom: 11,
				scrollwheel: false,
			});

			// Init routing
		    this.routing = new google.maps.DirectionsRenderer({
		    	// panel: this.routeElement
		    });
		    this.routing.setMap(this.map);

		    // Init text field
			this.autocomplete = new google.maps.places.Autocomplete(this.autocompleteElement);
		},

		ready: function() {
			var self = this;
			this.$form = $("#find-direction");
			this.$submitButton = this.$form.find("[type='submit']");
			this.$errorField = $("#find-direction_from_errors");

			// Find direction
			this.$form.submit(function(event) {
				event.preventDefault();
				self.clearErrors();
				self.disableForm();
				self.findDirection();
			});
		},

		findDirection: function() {
			var self = this;
			var request = {
		        origin : this.getPlace(),
		        destination : this.destination,
		        travelMode : google.maps.TravelMode.DRIVING,
		        provideRouteAlternatives: false,
		    };

		    var directionsService = new google.maps.DirectionsService();
		    directionsService.route(request, function(response, status) {
		    	self.enableForm();

		        if (status == google.maps.DirectionsStatus.OK) {
		        	self.success(response);
		        }
		        else {
		        	self.notFound();
		        }
		    });
		},

		getPlace: function() {
			var place = this.autocomplete.getPlace();
			if (place !== undefined && place.geometry !== undefined) {
				return { lat: place.geometry.location.lat(), lng: place.geometry.location.lng()	};
			}
			else if (place !== undefined && place.name !== undefined) {
				return place.name;
			}
			else {
				return this.autocompleteElement.value;
			}
		},

		disableForm: function() {
			this.$form.addClass("af-sending-request");
			this.$submitButton.prop("disabled", true);
		},

		enableForm: function() {
			this.$form.removeClass("af-sending-request");
			this.$submitButton.prop("disabled", false);
		},

		hideForm: function() {
			$("section.map .map-dialog").fadeTo(1000, 0, function(){
			   $(this).css("visibility", "hidden");
			});
		},

		clearErrors: function()
		{
			this.$form.find(".errors").empty();
			this.$form.find(".has-error").removeClass("has-error");
		},

		getRouteMidpoint: function(route) {
			var leg = route.routes[0].legs[0];
			var halfDistance = leg.distance.value / 2;
			for (var i = 0; i < leg.steps.length; ++i) {
				var step = leg.steps[i];
				halfDistance -= step.distance.value;
				if (halfDistance < 0) {
					return step.start_point;
				}
			}
			return this.destination;
		},

		success: function(route) {
			this.routing.setDirections(route);
			this.hideForm();

			if (this.infoWindow === null) {
				this.infoWindow = new google.maps.InfoWindow();
			}

			var midpoint = this.getRouteMidpoint(route);
			var distance = route.routes[0].legs[0].distance.text;
			var duration = route.routes[0].legs[0].duration.text;
			this.infoWindow.setContent("Délka <strong>" + distance + "</strong><br>Orientační čas <strong>" + duration + "</strong>");
			this.infoWindow.setPosition(midpoint);
			this.infoWindow.setMap(this.map);
		},

		notFound: function() {
			var error = "Trasa ze zadaného místa nebyla nalezena";
			this.$errorField.closest(".form-group").addClass("has-error");
			this.$errorField.append("<span class=\"help-block\">" + error + "</span>");
		},
	}


	// *************************************************************************
	// Initialization
	// *************************************************************************

	var googleMap = new GoogleMap();


	// *************************************************************************
	// Callbacks
	// *************************************************************************

	_.initMap = googleMap.init.bind(googleMap);
	$(document).ready(googleMap.ready.bind(googleMap));

}(jQuery, window));
